import PropTypes from 'prop-types'

// Internal components
import Svg from '../Svg/Svg'
import Button from '../Button/Button'

const PropertyBlock = (props) => {
  const { data, modifiers } = props
  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''
  return (
    <div className={`PropertyBlock${modifierClasses}`}>
      <ul className="PropertyBlock-list">
        {data.map((item, index) => {
          if (item.button) {
            return (
              <li className="PropertyBlock-item" key={`PropertyBlock-item-${index}`}>
                <Button icon={{ id: 'icon-detailtrigger' }} modifiers={item.button.modifiers} />
              </li>
            )
          } else if (item.label.length >= 1) {
            return (
              <li className="PropertyBlock-item" key={`PropertyBlock-item-${index}`}>
                <span className="PropertyBlock-icon">
                  <Svg id={`icon-${item.icon}`} modifiers={['PropertyBlock-svg']} />
                </span>
                <span className="PropertyBlock-label">{item.label}</span>
              </li>
            )
          } else return false
        })}
      </ul>
    </div>
  )
}

PropertyBlock.propTypes = {
  data: PropTypes.array,
  modifiers: PropTypes.array
}

export default PropertyBlock
